export const fmtTRY = (n, decimals = 0) =>
  new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n || 0) + " ₺";

export const fmtNum = (n) => new Intl.NumberFormat("tr-TR").format(n || 0);

export const fmtDate = (s) => {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
};
